export default __webpack_public_path__ + "static/media/symbol.80676784.svg";